import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";

export class CuratedItem
{ 
  static readonly type  = new ElementType( "curated-item" );
  static readonly point = new ElementType( "curated-point" );
  static readonly pointContent = new ElementType( "curated-point-content" );
  static readonly title = new ElementType( "curated-title" );
  static readonly copy = new ElementType( "curated-copy" );
  static readonly closeButton = new ElementType( "close-button" );

  static readonly view = new ElementAttribute( "view" );

  static readonly list    = new AttributeValue( CuratedItem.view, "list" );
  static readonly compact    = new AttributeValue( CuratedItem.view, "compact" );
  static readonly allDetails = new AttributeValue( CuratedItem.view, "all-details" );

  static readonly detailsToggle = new ElementAttribute( "details-toggle" );

  static applyOnDocument()
  {
    CuratedItem.type.forAllInDoc( e => this.applyOnElement( e ) );
  }
  
  static applyOnElement( e:Element )
  { 
    
  }

}